import { Season } from './../../models';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore';
@Component({
  selector: 'app-e-comic-pricing-form',
  templateUrl: './e-comic-pricing-form.component.html',
  styleUrls: ['./e-comic-pricing-form.component.css']
})
export class EComicPricingFormComponent implements OnInit {
  comicpricingForm: FormGroup;
  showprice: any = false;
  id: any;
  price: any;
  loading: boolean = false;
  load: boolean = false;
  constructor(private form: FormBuilder, private router: Router, private afs: AngularFirestore, private route: ActivatedRoute) { }

  ngOnInit() {
    this.comicpricingForm = this.form.group({
      seasonprice: ['', [Validators.required]],
      seasonvalidity: ['', [Validators.required]],
      episodeprice: ['', [Validators.required]],
      episodevalidity: ['', [Validators.required]],
      status: ['', [Validators.required]],
      IsAllowPointsPurchase:["false",[Validators.required]],
    });
    if (this.route.firstChild) {
      this.route.firstChild.params.subscribe(params => {
        this.id = params['id'];
        if (this.id) {
          const seasondoc: AngularFirestoreDocument<Season> = this.afs.doc('Ecomicseason/' + this.id)
          seasondoc.valueChanges().subscribe(singleepisode => {
            this.price = singleepisode.pricing_type;
            if (this.price != 'Free') {
              const pricedetails = singleepisode.prices;
              this.comicpricingForm.get('seasonprice').setValue(pricedetails['seasonprice']);
              this.comicpricingForm.get('seasonvalidity').setValue(pricedetails['seasonvalidity']);
              this.comicpricingForm.get('episodeprice').setValue(pricedetails['episodeprice']);
              this.comicpricingForm.get('episodevalidity').setValue(pricedetails['episodevalidity']);
              this.comicpricingForm.get('IsAllowPointsPurchase').setValue(String(pricedetails['IsAllowPointsPurchase']));
            }
            this.showprice = true;
          });
        }
      });
    }

  }

  addpricing(value, valid) {
    try {
      if (value.status != 'Free') {
        if (valid) {
          this.loading=true;
          console.log(value);
          this.afs.doc('Ecomicseason/' + this.id).update({ pricing_type: value.status, prices: value,IsAllowPointsPurchase:JSON.parse(value.IsAllowPointsPurchase)});
          this.router.navigate(['/comic-seasons']);
        } else {
          this.loading=false;
          this.load=true;
          console.log('error');
        }
      } else {
        this.afs.doc('Ecomicseason/' + this.id).update({ pricing_type: 'Free' });
        this.router.navigate(['/comic-seasons']);
      }
    } catch (error) {
      console.log(error);
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/E-comics/e-comic-pricing-form/e-comic-pricing-form.component.ts